import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询企业/会员列表
export const querySubOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSubOrgs', { ...state.subOrgs, loading: true });
    const { list, total, pageNum, pageSize } = await $http.post('/v1/system/suborg/search', payload);
    commit('setSubOrgs', { data: list, total, pageNum, pageSize });
  } catch (e) {
    commit('setSubOrgs', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询父组织详情
export const queryParentOrgDetail: IActionFn<IModuleState> = async ({ commit, state }, parentOrgId) => {
  try {
    commit('setParentOrgDetail', { ...state.parentOrgDetail, loading: true });
    const res = await $http.get(`baseinfo/enterprise/${parentOrgId}`);
    commit('setParentOrgDetail', { data: res });
  } catch (e) {
    commit('setParentOrgDetail', { data: null });
  }
};

// 新增子组织
export const addSubOrgs: IActionFn<IModuleState> = async ({ dispatch, commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('baseinfo/enterprise/add', payload);
    await dispatch('queryParentOrgDetail', payload.parentId);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑子组织
export const editSubOrgs: IActionFn<IModuleState> = async ({ dispatch, commit }, payload) => {
  try {
    commit('setLoading', true);
    const { parentId, ...rest } = payload;
    await $http.post('/baseinfo/enterprise/modify', rest);
    await dispatch('queryParentOrgDetail', parentId);
  } finally {
    commit('setLoading', false);
  }
};

// 删除子组织
export const deleteSubOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/delete', { orgId: payload });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询子组织待授权的品牌列表
export const queryUnAuthedBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUnAuthedBrands', { ...state.unAuthedBrands, loading: true });
    const { list, total, pageNum, pageSize } = await $http.post('/baseinfo/suborg/brand/list', payload);
    commit('setUnAuthedBrands', { data: list, total, pageNum, pageSize });
  } catch (e) {
    commit('setUnAuthedBrands', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询子组织已授权的品牌列表
export const queryAuthedBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuthedBrands', { ...state.authedBrands, loading: true });
    const { list, total, pageNum, pageSize } = await $http.post('/v1/system/org/authbrands', payload);
    commit('setAuthedBrands', { data: list, total, pageNum, pageSize });
  } catch (e) {
    commit('setAuthedBrands', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 为子组织添加授权品牌
export const addAuthBrandToSubOrg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/authorization/ref/brand/suborg/create', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除子组织的授权品牌
export const deleteAuthBrandFromSubOrg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/authbrand/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
